const CONTACT_SEARCH_TEXT_FIELDS = ['name', 'firstName', 'lastName', 'email'] as const;
// NOTE: internationalPhoneFormat / countryCallingCode are NOT columns on ChatUsers
// (a planned-but-dropped feature). Searching them produced 'Invalid column name'
// 500s on the node /getContacts. Phone search runs on `phone` (UserId) with the
// local/972/+ variants from getPhoneSearchVariants, which covers all formats.
const CONTACT_SEARCH_PHONE_FIELDS = ['phone'] as const;

type ContactSearchCondition = {
  field: string;
  operator: 'contains';
  value: string;
};

/** וריאציות טלפון לחיפוש — מקומי (05…), בינלאומי (972…) ועם + */
export function getPhoneSearchVariants(term: string): string[] {
  const trimmed = term.trim();
  if (!trimmed) return [];

  const variants = new Set<string>([trimmed]);
  const digits = trimmed.replace(/\D/g, '');

  if (!digits) return [...variants];

  variants.add(digits);

  if (digits.startsWith('0') && digits.length >= 9) {
    variants.add(`972${digits.slice(1)}`);
  }

  if (digits.startsWith('972') && digits.length >= 11) {
    variants.add(`0${digits.slice(3)}`);
  }

  if (!trimmed.startsWith('+') && digits.length >= 7) {
    variants.add(`+${digits}`);
  }

  return [...variants].filter((v) => v.length > 0);
}

/** פילטר OR לחיפוש אנשי קשר — שמות, טלפון מפורט ווריאציות מספר */
export function buildContactSearchTermFilter(
  searchTerm: string,
): { logic: 'or'; conditions: ContactSearchCondition[] } | null {
  const trimmed = searchTerm.trim();
  if (!trimmed) return null;

  const conditions: ContactSearchCondition[] = [];
  const seen = new Set<string>();

  const pushCondition = (field: string, value: string) => {
    const key = `${field}:${value}`;
    if (seen.has(key)) return;
    seen.add(key);
    conditions.push({ field, operator: 'contains', value });
  };

  for (const field of CONTACT_SEARCH_TEXT_FIELDS) {
    pushCondition(field, trimmed);
  }

  const phoneVariants = getPhoneSearchVariants(trimmed);
  for (const field of CONTACT_SEARCH_PHONE_FIELDS) {
    for (const value of phoneVariants) {
      pushCondition(field, value);
    }
  }

  return { logic: 'or', conditions };
}
